import {EditProps} from "react-admin";
import {JournalEntryForm} from "./JournalEntryForm";
import {DefaultEdit} from "../../components/DefaultEdit";

export const JournalEntryEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props}>
      <JournalEntryForm />
    </DefaultEdit>
  );
};
